import { inject, Injectable } from '@angular/core';
import { ShellStore } from '@partners/state';
import { ThemeConfig } from '@partners/themes';

@Injectable({
  providedIn: 'root'
})
export class ShellThemeConfig extends ThemeConfig {
  #shellStore = inject(ShellStore);

  get themeRoot(): string {
    return './themes';
  }

  get themeIconSet(): string {
    return 'icon-sets';
  }

  get themeSuffix(): string {
    return 'theme';
  }

  get themeName(): string {
    return this.#shellStore.params$$().theme;
  }

  /** the custom theme's assets path name */
  get themeSource(): string {
    return this.#shellStore.params$$().partner;
  }

  get themeFileId(): string {
    return 'partner';
  }
}
